import * as React from "react";
import { AccessoriesEcommProvider, EcommFacetProvider, ProductImageGallery, AccessoriesEcommContent, useProductDetailSlots, ProductDetailFullWidth, StickyMobileCtaAndPrice, AccessoriesCTA, ProductDetailStack, ProductDetailDescription, ProductDetailDisclaimer, ProductDetailDrawerStack, ProductDetailSpecification, ProductDetailManufacturerDrawer, ProductDetailReviewsDrawer, mapServerToAccessoriesProduct, getAccessoriesBySlug } from "@grandvisionhq/fun-products";
import { P as ProductPageLayoutBase, a as ProductPageBase, d as defaultAccessoriesFacetConfig, f as fetchProductConfigBySlug, h as handleValidations } from "../../ProductPageLayoutBase.js";
import { d as defaultAccessoriesFlatFacetConfig } from "../../default-flat-facet-configs.js";
import { CmsComponentSlot } from "@grandvisionhq/bloomreach";
const EcommContent = AccessoriesEcommContent;
const PrimaryProductInfo = (props) => /* @__PURE__ */ React.createElement(ProductDetailStack, { ...props }, /* @__PURE__ */ React.createElement(ProductDetailDescription, { className: "product-detail-stack__description" }), /* @__PURE__ */ React.createElement(ProductDetailDisclaimer, { className: "product-detail-stack__disclaimer" }), /* @__PURE__ */ React.createElement(ProductDetailDrawerStack, { className: "product-detail-stack__drawer-stack" }, /* @__PURE__ */ React.createElement(ProductDetailSpecification, null), /* @__PURE__ */ React.createElement(ProductDetailManufacturerDrawer, null), /* @__PURE__ */ React.createElement(ProductDetailReviewsDrawer, null)));
const StickyCta = (props) => /* @__PURE__ */ React.createElement(StickyMobileCtaAndPrice, { ...props, cta: /* @__PURE__ */ React.createElement(AccessoriesCTA, null) });
const SecondaryProductInfo = () => {
  const { Slots: OpcoSlots } = useProductDetailSlots();
  return /* @__PURE__ */ React.createElement(ProductDetailFullWidth, null, /* @__PURE__ */ React.createElement(CmsComponentSlot, { path: "main/row-pdp-container" }), OpcoSlots.SecondaryProductInfoSlot && /* @__PURE__ */ React.createElement(OpcoSlots.SecondaryProductInfoSlot, null));
};
const AccessoriesDetailPage = ({ maxOrderableQuantity }) => {
  return /* @__PURE__ */ React.createElement(AccessoriesEcommProvider, { maxOrderableQuantity }, /* @__PURE__ */ React.createElement(EcommFacetProvider, null, /* @__PURE__ */ React.createElement(
    ProductPageLayoutBase,
    {
      EcommContent,
      ImageGallery: ProductImageGallery,
      PrimaryProductInfo,
      StickyCta,
      SecondaryProductInfo
    }
  )));
};
const Page = ({
  maxOrderableQuantity,
  facetConfigList,
  ...props
}) => /* @__PURE__ */ React.createElement(ProductPageBase, { ...props, facetConfigList: facetConfigList ?? defaultAccessoriesFacetConfig }, /* @__PURE__ */ React.createElement(AccessoriesDetailPage, { maxOrderableQuantity }));
Page.getInitialProps = async (ctx) => {
  const productConfig = await fetchProductConfigBySlug(
    ctx,
    getAccessoriesBySlug,
    mapServerToAccessoriesProduct,
    ctx.pageConfig?.facetConfigList ?? defaultAccessoriesFacetConfig,
    ctx.pageConfig?.flatFacetConfigList ?? defaultAccessoriesFlatFacetConfig
  );
  if ("failure" in productConfig) {
    return handleValidations(productConfig, `Error while initializing Accessories PDP`);
  }
  const { product, activeVariant, sku, slug, bloomreachPathOverride } = productConfig;
  return {
    sku,
    slug,
    product,
    activeVariant,
    bloomreachPathOverride
  };
};
export {
  Page
};
//# sourceMappingURL=accessories.js.map
